<form [formGroup]="form">
  <app-form-control label="Etykieta">
    <input
      [formControl]="form.controls.label"
      appPrimengInputText
      pInputText />
  </app-form-control>

  @if (shouldBeVisible('slug')) {
    <app-form-control label="Slug">
      <input
        [formControl]="form.controls.slug"
        appPrimengInputText
        pInputText />
    </app-form-control>
  }

  <app-form-control label="Pozycja / kolejność">
    <input
      [formControl]="form.controls.position"
      appPrimengInputText
      pInputText
      type="number" />
  </app-form-control>

  <div class="flex justify-end">
    <p-button
      (onClick)="handleSubmitClick()"
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz"
      severity="primary"
      type="submit" />
  </div>
</form>
